import * as React from 'react';
import { SignOut } from 'aws-amplify-react';

interface OwnProps {

};
export const CustomSignOut: React.SFC<OwnProps> = (props: OwnProps) => {
  return (<SignOut />);
}



// WEBPACK FOOTER //
// ./src/components/parts/CustomSignOut.tsx